import { type RefObject, useEffect } from 'react';

const useClickOutside = (modalRef: RefObject<HTMLDivElement> | null, dismiss: () => void) => {
    useEffect(() => {
        if (!modalRef?.current) return;

        const handleMouseDownOutside = (event: MouseEvent) => {
            if (modalRef.current && !modalRef.current.contains(event.target as Node)) {
                dismiss();
            }
        };

        document.addEventListener('mousedown', handleMouseDownOutside);
        return () => {
            document.removeEventListener('mousedown', handleMouseDownOutside);
        };
    }, [dismiss, modalRef]);

    return null;
};

export default useClickOutside;
